import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { getOrders, selectOrders } from '../../orders/orders';
import { selectServices } from '../../app/services';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Addresses from './Addresses';
import Orders from './Orders';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Settings from './Settings';
import Certificate from './Certificate';

export class Dashboard extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        orders: ImmutablePropTypes.orderedMap.isRequired,
        services: ImmutablePropTypes.map.isRequired,
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.dispatch(getOrders());
    }

    render() {
        return (
            <Page.Body>
                <Page.Section depth={0}>
                    <h2>
                        <FormattedMessage id='frontend.orders.headline' />
                    </h2>
                </Page.Section>
                <Page.Section>
                    <Orders />
                </Page.Section>
                <Page.Section depth={0}>
                    <h2>
                        <FormattedMessage id='addressbook.title.addressbook' />
                    </h2>
                </Page.Section>
                <Page.Section>
                    <Addresses />
                </Page.Section>
                <Page.Section depth={0}>
                    <h2>
                        <FormattedMessage id='frontend.settings.headline.intro' />
                    </h2>
                </Page.Section>
                <Page.Section>
                    <Settings />
                </Page.Section>
                <Page.Section depth={0}>
                    <h2>
                        <FormattedMessage id='frontend.certificate.text.my_certificate' />
                    </h2>
                </Page.Section>
                <Page.Section>
                    <Certificate />
                </Page.Section>
            </Page.Body>
        );
    }
}

export default connect(state => ({
    orders: selectOrders(state),
    services: selectServices(state),
}))(Dashboard);
